<template>
  <div>
    <v-app-bar
      class="main-header"
      height="80"
      fixed
      color='white'
      app
      v-if="visible"
      clipped-left
      clipped-right
    >
      <v-app-bar-nav-icon class="hidden-md-and-up" color="black" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-navigation-drawer
        floating
        absolute
        app
        disable-resize-watcher
        v-model="drawer"
      >
        <v-list
          nav
          dense
        >
          <v-list-item-group>
              <v-list-item>
                <v-icon>mdi-search-web</v-icon>
                <input
                  v-model="search_word"
                  type="text"
                  placeholder="トピックを検索"
                  @keypress.enter="search"
                  style="width:90%;"
                >
            </v-list-item>
            <v-list-item link :to="{name: 'home'}">ホーム</v-list-item>
          </v-list-item-group>
          <v-list-item-group v-if="isLogin">
            <v-list-item v-if="!drawer" link to="topic_create">トピック作成</v-list-item>
            <v-list-item link :to="{ name: 'user', params: { user_code: getUserCode }}">マイページ</v-list-item>
            <v-list-item @click="openModal">通知<span v-show="isNewNoticeBadge" class="badge">{{newNoticeCount > 9 ? '9+' : newNoticeCount}}</span></v-list-item>
          </v-list-item-group>
          <v-list-item-group v-else>
            <v-list-item link :to="{name: 'signup'}">新規登録</v-list-item>
            <v-list-item link :to="{name: 'login'}">ログイン</v-list-item>
          </v-list-item-group>
          <v-list-item-group>
            <v-list-item link :to="{name: 'company'}">運営会社</v-list-item>
            <v-list-item link :to="{name: 'terms'}">利用規約</v-list-item>
            <v-list-item link :to="{name: 'privacy'}">個人情報の取り扱い</v-list-item>
            <v-list-item link :to="{name: 'inquiry'}">お問い合わせ</v-list-item>
            <v-list-item link :to="{name: 'help'}">ヘルプ</v-list-item>
          </v-list-item-group>
        </v-list>

      </v-navigation-drawer>
      <v-spacer class="hidden-md-and-up" />
      <v-app-bar-title>
        <router-link class="routerLink" to="/"><img src="../../assets/logo_text_black.svg" height="90" width="150" class="mt-4"></router-link>
      </v-app-bar-title>
      <v-spacer class="hidden-sm-and-down" />
      <v-row>
        <v-text-field
          light
          prepend-inner-icon="mdi-magnify"
          placeholder="トピック検索"
          type="string"
          v-model="search_word"
          filled
          dense
          rounded
          hide-details
          @keydown.enter="search"
          class="shrink font-weight-bold hidden-sm-and-down"
          style="width:90%;"
          background-color='#F4F4F4'
        >
        </v-text-field>
      </v-row>
      <template v-if="isLogin">
        <v-btn href="/" color='#FFFFFF' class="ma-2 hidden-sm-and-down"><v-icon>mdi-home</v-icon></v-btn>
        <v-btn light @click="openModal" color='#FFFFFF' class="ma-2 hidden-sm-and-down">
          <v-badge
          color="pink"
          :content="newNoticeCount > 9 ? '9+' : newNoticeCount"
          :value="isNewNoticeBadge"
        ><v-icon>{{bellType}}</v-icon></v-badge>
        </v-btn>
        <v-btn light :to="{ name: 'topic_create' }" color='#FFFFFF' class="ma-2 font-weight-bold blue-grey--text hidden-sm-and-down"><v-icon>mdi-file-plus-outline</v-icon>トピック作成</v-btn>
        <v-btn light :href="'/user/' + getUserCode" color='#FFFFFF' class="ma-2 font-weight-bold blue-grey--text hidden-sm-and-down"><v-icon>mdi-account-box-outline</v-icon>マイページ</v-btn>
        <v-btn :to="{ name: 'logout'}" color='#5E00BC' class="ma-2 font-weight-bold hidden-sm-and-down" style="color: #FFFFFF;"><v-icon>mdi-logout</v-icon>ログアウト</v-btn>
        <v-btn elevation="0" color="#FFFFFF" :to="{ name: 'logout'}" style="color: #797884; padding: 0 !important;" class="font-weight-bold hidden-md-and-up">ログアウト</v-btn>
      </template>
      <template v-else>
        <v-btn href="/" color='#FFFFFF' class="ma-2 hidden-sm-and-down"><v-icon>mdi-home</v-icon></v-btn>
        <v-btn light href="/signup" color='#FFFFFF' class="ma-2 font-weight-bold blue-grey--text hidden-sm-and-down"><v-icon>mdi-account-plus-outline</v-icon>新規登録</v-btn>
        <v-btn href="/login" color='#5E00BC' class="ma-2 font-weight-bold hidden-sm-and-down" style="color: #FFFFFF;"><v-icon>mdi-login-variant</v-icon>ログイン</v-btn>
      </template>
    </v-app-bar>
    <v-dialog content-class="notice-dialog" v-model="isNoticeModal" @click:outside="closeModal" @keydown.esc="closeModal" width="340" hide-overlay>
      <NoticeList style="height: 345px; background-color: white;" :closeModal="closeModal" :noticeList="noticeList" :setUnReadNotice="setUnReadNotice" />
    </v-dialog>
  </div>
</template>

<script>
import NoticeList from './NoticeList.vue';
export default {
  name: 'GlobalHeader',
  data() {
    return {
      search_word: "",
      visible: true,
      hide: ['login', 'signup', 'cooperateSignup', 'signup_confirm', 'signup_success', 'thank_you', 'password_reset', 'password_reset_input', 'password_reset_success', 'password_reset_failed', 'email_verifiy', 'inquiryFinish'],
      isNoticeModal: false,
      noticeList: [],
      drawer: false,
    };
  },
  computed: {
    isLogin: function() {
      return this.$store.getters['auth/isAuth']
    },
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
    bellType() {
      return this.isNoticeModal ? 'mdi-bell' : 'mdi-bell-outline';
    },
    isNewNoticeBadge() {
      return this.$store.getters['notice/unReadNotice'] === 0 ? false : true;
    },
    newNoticeCount() {
      return this.$store.getters['notice/unReadNotice'] > 9 ? '9+' : this.$store.getters['notice/unReadNotice'];
    }
  },
  async mounted() {
    if(this.hide.includes(this.$route.name)) {
      this.visible = false
    }
    if (this.isLogin) {
      this.setUnReadNotice();
      this.polling();
    }
  },
  methods: {
    search: function (event) {
      if (this.search_word === "") {
        return;
      }
      if (this.search_word === "vla.tips endroll") {
        this.getSecretEndroll();
      }
      if (event.keyCode !== 13) return
      this.$router.push({ path: '/search_result', query: { search: this.search_word } })
        .catch((error) => {
          // 同じurl(クエリも含めたfullpath)に遷移する際にvue.jsが警告してくれているので握りつぶしている
          console.log(error);
        })
    },
    async openModal() {
      this.isNoticeModal = true;
      await this.getNotice(1)
      this.noticeList = this.$store.getters['notice/noticeList'];
    },
    closeModal() {
      this.isNoticeModal = false;
      this.$store.dispatch('notice/resetNotice');
      this.noticeList = this.$store.getters['notice/noticeList'];
    },
    async getNotice(page) {
      await this.$store.dispatch('notice/get', page);
    },
    async setUnReadNotice() {
      await this.$store.dispatch('notice/getUnReadNotice');
    },
    // 10分毎に未読通知を取得している
    polling() {
      setInterval(() => {
        // タブを複数開いているとその分APIが叩かれてしまうためアクティブなタブでのみAPI通信
        if (document.visibilityState === 'visible') {
          this.setUnReadNotice()
        }
      }, 600000)
    },
    getSecretEndroll() {
      var w = (screen.width - 640) / 2;
      var h = (screen.height - 480) / 2;
      window.open("endroll.html","sub","width=640,height=480,"+
        "left=" + w + ",top=" + h + ",scrollbars=no,menubar=no,toolbar=no,location=no");
    }
  },
  components: {
    NoticeList
  },
};
</script>
<style scoped>
.header {
  background-color: #ffffff;
}
.routerLink{
  text-decoration: none;
}
>>> .notice-dialog {
  top: 60px !important;
  right: 0 !important;
  position: absolute !important;
}
.icon {
  background-color: gray;
}
.badge {
  background-color: #E91E63;
  margin-left: 1rem;
  color: #ffffff;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
}
</style>